
export class JWTokenModel {
  jwToken: string;

}

